
/** @format */

import React, { type Ref } from 'react'

const cx = (...classes: (string | boolean | undefined | null)[]) => classes.filter(Boolean).join(' ')

export const DashboardWrapper = ({ className, style, children, ref, ...props }: any & { ref?: Ref<any> }) => (
  <div
    ref={ref}
    className={cx('[&_.uppy-size--md_.uppy-Dashboard-AddFiles-title]:!text-base', className)}
    style={style}
    {...props}
  >
    {children}
  </div>
)
DashboardWrapper.displayName = 'DashboardWrapper'
